
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<Checkbox>({
    model: {
        prop: 'checked',
        event: 'change',
    },
})
export default class Checkbox extends Vue {
    @Prop({ type: String, required: false })
    public readonly id?: string
    @Prop({ type: String, required: false })
    public readonly name?: string
    @Prop({ type: Boolean, required: false, default: false })
    public readonly checked!: boolean
    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean
    @Prop({ type: Boolean, required: false, default: false })
    public readonly circle!: boolean
    @Prop({ type: String, required: false, default: '' })
    public readonly colourVariant!: boolean

    public hovered = false

    public handleChange() {
        if (this.disabled) {
            return
        }
        this.$emit('change', !this.checked)
    }
}
